import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import axios from 'axios';
import Grid from '@material-ui/core/Grid';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Clear from '@material-ui/icons/Clear';
import Skeleton from '@material-ui/lab/Skeleton';
import Button from '@material-ui/core/Button';
import { LoadingButton } from '@mui/lab';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import Typography from '@material-ui/core/Typography';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import AddIcon from '@material-ui/icons/Add';
import { useSnackbar } from 'notistack';
import { Chip, MenuItem, TableFooter, TextField } from '@material-ui/core';
import { Box, TablePagination } from '@mui/material';

import { AuthContext } from '@jumbo/components/context/AuthContext';
import RefreshToken from 'routes/partials/RefreshToken';
// import AgentReqEdit from './AgentReqEdit';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 450,
  },

  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  dialogButtonSection: {
    padding: '8px 20px',
    justifyContent: 'space-between',
  },
  floatRight: {
    position: 'absolute',
    top: 3,
    right: 3,
  },

  container: {
    maxHeight: 'calc(100vh - 330px)',
    overflow: 'auto',
  },

  cellWidth: {
    width: '230px',
  },

  tableHeadStyle: {
    '& th': {
      fontWeight: 600,
      fontSize: '1rem',
      backgroundColor: '#000132',
      color: 'white',
    },
  },

  tableBodyStyle: {
    '& td': {
      padding: '8px 16px',
    },
  },

  detailButton: {
    color: '#C3C8C8',
    // margin: '0 5px',
    // border: '1px solid #C3C8C8',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#F1F1F1' },
  },
  editButton: {
    color: '#00C4B4',
    // margin: '0 5px',
    // border: '1px solid #66BD4E',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#00C4B410' },
  },
  titleStyle: {
    marginBottom: '1rem',
  },
  buttonStyle: {
    borderRadius: '25px',
  },
  dialogStyle: {
    width: '600px',
  },
  dialogStyleImage: {
    width: '800px',
  },
  alignCenter: {
    textAlign: 'center',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  image: {
    cursor: 'zoom-in',
  },
}));

const KycList = () => {
  const classes = useStyles();
  const { glob_pay_admin_auth, logout, login } = useContext(AuthContext);

  const { enqueueSnackbar } = useSnackbar();
  const [list, setList] = useState([]);
  const [allCountry, setAllCountry] = useState([]);
  const [allState, setAllState] = useState([]);
  const [allCity, setAllCity] = useState([]);
  const [allDocumentType, setAllDocumentType] = useState([]);
  const [allOccupation, setAllOccupation] = useState([]);
  const [detailViewItem, setDetailViewItem] = useState({});
  const [openDetailView, setOpenDetailView] = useState(false);
  const [editObj, setEditObj] = useState({});
  const [editIndexNo, setEditIndexNo] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [message, setMessage] = useState('There is no data');
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const [addDialog, setAddDialog] = useState(false);
  const [addDialogImage, setAddDialogImage] = useState(false);
  const [popupImage, setPopupImage] = useState('');
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [count, setCount] = useState(0);

  const [fullName, setFullName] = useState('');
  const [documentId, setDocumentId] = useState('');
  const [documentTypeId, setDocumentTypeId] = useState('');
  const [occupation, setOccupation] = useState('');
  const [countryId, setCountryId] = useState('');
  const [stateId, setStateId] = useState('');
  const [cityId, setCityId] = useState('');
  const [stage, setStage] = useState('');
  const [username, setUsername] = useState('');
  const [eKycApproval, setEKycApproval] = useState('');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const openAddDialog = () => {
    setAddDialog(true);
  };
  const closeAddDialog = (event, reason) => {
    if (reason && reason == 'backdropClick') return;

    setAddDialog(false);
  };

  const openAddDialogImage = () => {
    setAddDialogImage(true);
  };
  const closeAddDialogImage = () => {
    console.log('closeAddDialog');
    setAddDialogImage(false);
  };
  // ==================Delete Dialogue start==============================
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const handleDeleteDialogClickOpen = () => {
    setDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialog(false);
  };
  // ==================Delete Dialogue End==============================

  const handleClickOpenDetailView = () => {
    setOpenDetailView(true);
  };

  const handleCloseDetailView = () => {
    setOpenDetailView(false);
  };

  const handleClickView = item => {
    setDetailViewItem(item);
    handleClickOpenDetailView();
  };

  const handleSearch = () => {
    getList();
  };
  const handleClear = () => {
    setFullName('');
    setDocumentId('');
    setDocumentTypeId('');
    setCountryId('');
    setStateId('');
    setCityId('');
    setStage('');
    setUsername('');
    getListAll();
  };

  const getListAll = async () => {
    setLoading(true);

    let token = await RefreshToken(glob_pay_admin_auth, logout, login);
    let uri = `${process.env.REACT_APP_BASE_URL}/api/v1/private/admin/e-kyc?page=${page}&size=${perPage}`;
    let url = new URL(uri);

    await axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(function(response) {
        setList(response.data.content);
        setCount(response.data.totalElements);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response.data.error);
      });
    setLoading(false);
  };

  const getList = async () => {
    setLoading(true);

    let token = await RefreshToken(glob_pay_admin_auth, logout, login);
    let uri = `${process.env.REACT_APP_BASE_URL}/api/v1/private/admin/e-kyc?page=${page}&size=${perPage}`;
    let url = new URL(uri);
    if (fullName) {
      url.searchParams.append('fullName', fullName.trim());
    }
    if (documentId) {
      url.searchParams.append('documentId', documentId.trim());
    }
    if (documentTypeId) {
      url.searchParams.append('documentTypeId', documentTypeId.trim());
    }
    if (countryId) {
      url.searchParams.append('countryId', countryId.trim());
    }
    if (stateId) {
      url.searchParams.append('stateId', stateId.trim());
    }
    if (cityId) {
      url.searchParams.append('cityId', cityId.trim());
    }
    if (stage) {
      url.searchParams.append('stage', stage);
    }
    if (username) {
      url.searchParams.append('username', username.trim());
    }

    await axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(function(response) {
        console.log('element', response.data.totalElements);
        setList(response.data.content);
        setCount(response.data.totalElements);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response.data.error);
      });
    setLoading(false);
  };

  const getCountry = async () => {
    await axios
      .get(`/api/v1/private/ekyc/country-list`)
      .then(function(response) {
        setAllCountry(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response && error.response.data && error.response.data.error);
      });
  };

  const getCity = async () => {
    await axios
      .get(`/api/v1/private/ekyc/city-list?stateId=${stateId}`)
      .then(function(response) {
        setAllCity(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response && error.response.data && error.response.data.error);
      });
  };

  const getState = async () => {
    await axios
      .get(`/api/v1/private/ekyc/state-list?countryId=${countryId}`)
      .then(function(response) {
        setAllState(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response && error.response.data && error.response.data.error);
      });
  };

  const getDocumentType = async () => {
    await axios
      .get(`/api/v1/private/ekyc/document-type`)
      .then(function(response) {
        setAllDocumentType(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response && error.response.data && error.response.data.error);
      });
  };

  const getOccupation = async () => {
    await axios
      .get(`/api/v1/private/ekyc/occupation-list`)
      .then(function(response) {
        setAllOccupation(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response && error.response.data && error.response.data.error);
      });
  };

  const getById = async id => {
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    await axios
      .get(`/api/v1/private/agent/request/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function(response) {
        console.log('res', response);
        setEditObj(response.data.data);
        openAddDialog();
      })
      .then()
      .catch(function(error) {
        // handle error
        console.log(error);
        // setMessage(error.response.data.error);
      });
  };
  const handleDelete = async () => {
    // return console.log('handleDeleteID', deleteId);
    setLoadingDelete(true);
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    await axios
      .delete(`/api/v1/private/agent/request/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function(response) {
        console.log('res.id', response);
        let newList = list.filter(res => res.id !== deleteId);
        console.log('newList', newList);
        setList(newList);
        setDeleteDialog(false);
        handleSnakbarOpen(response.data.message, 'success');
      })
      .catch(function(error) {
        // handle error
        setDeleteDialog(false);
        handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      });
    setLoadingDelete(false);
  };

  const handleApprove = async (e, kycId) => {
    e.preventDefault();
    setLoading(true);
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);
    let data = new FormData();
    data.append('userId', kycId);
    data.append('eKycApproval', eKycApproval);
    // let data = {
    //   userId: kycId,
    //   eKycApproval,
    // };

    try {
      let response = await axios({
        url: `/api/v1/private/admin/e-kyc`,
        method: 'put',
        data: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      handleSnakbarOpen(response.data.message, 'success');
      getList();
      setOpenDetailView(false);
      setEKycApproval('');
    } catch (error) {
      handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      setOpenDetailView(false);
    }
    setLoading(false);
  };

  const pageLoading = () => {
    let content = [];

    for (let i = 0; i < 20; i++) {
      content.push(
        <TableRow key={i}>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
        </TableRow>,
      );
    }
    return content;
  };
  useEffect(() => {
    getCity();
  }, [stateId]);
  useEffect(() => {
    getState();
  }, [countryId]);
  useEffect(() => {
    getList();
  }, [page]);
  useEffect(() => {
    getCountry();
    getDocumentType();
    // getOccupation()
  }, []);

  return (
    <React.Fragment>
      <Grid container alignItems="center" className={classes.titleStyle} spacing={3}>
        <Grid item md={8}>
          <Typography variant="h2">KYC Request List</Typography>
        </Grid>
        <Grid item md={4} style={{ textAlign: 'right' }}>
          {/* <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            onClick={openAddDialog}
            startIcon={<AddIcon />}>
            Add New
          </Button> */}
        </Grid>
        <Grid item md={3}>
          <TextField
            label="Full Name"
            variant="outlined"
            fullWidth
            size="small"
            className={`${classes.marginStyle} ${classes.inputStyle}`}
            value={fullName}
            onChange={e => setFullName(e.target.value)}
          />
        </Grid>
        <Grid item md={3}>
          <TextField
            label="User Name"
            variant="outlined"
            fullWidth
            size="small"
            className={`${classes.marginStyle} ${classes.inputStyle}`}
            value={username}
            onChange={e => setUsername(e.target.value)}
          />
        </Grid>
        <Grid item md={3}>
          <TextField
            label="Document ID"
            variant="outlined"
            fullWidth
            size="small"
            className={`${classes.marginStyle} ${classes.inputStyle}`}
            value={documentId}
            onChange={e => setDocumentId(e.target.value)}
          />
        </Grid>
        <Grid item md={3}>
          {/* <TextField
            label="Stage"
            variant="outlined"
            fullWidth
            size="small"
            className={`${classes.marginStyle} ${classes.inputStyle}`}
            value={stage}
            onChange={e => setStage(e.target.value)}
          /> */}
          <TextField
            variant="outlined"
            select
            label="Stage"
            size="small"
            fullWidth
            required
            value={stage}
            onChange={e => setStage(e.target.value)}
            className={`${classes.marginStyle} ${classes.inputStyle}`}>
            <MenuItem value={'0'}>EKYC journey not started / declined</MenuItem>
            <MenuItem value={1}>Document submitted</MenuItem>
            <MenuItem value={2}>Form Submitted</MenuItem>
            <MenuItem value={3}>Verified</MenuItem>
            <MenuItem value={4}>Approved by Admin</MenuItem>
          </TextField>
        </Grid>

        <Grid item md={3}>
          <TextField
            variant="outlined"
            select
            label="Country"
            size="small"
            fullWidth
            required
            value={countryId}
            onChange={e => setCountryId(e.target.value)}
            className={`${classes.marginStyle} ${classes.inputStyle}`}>
            {allCountry.map((e, index) => (
              <MenuItem value={e.id} key={index}>
                <Box className={classes.inner}>
                  <img src={e.flag} style={{ maxWidth: 24, marginRight: 10 }} alt="" /> {e.name}
                </Box>
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item md={3}>
          <TextField
            variant="outlined"
            select
            label="State"
            size="small"
            fullWidth
            required
            value={stateId}
            onChange={e => setStateId(e.target.value)}
            className={`${classes.marginStyle} ${classes.inputStyle}`}>
            {allState.map((e, index) => (
              <MenuItem value={e.id} key={index}>
                <Box className={classes.inner}> {e.name}</Box>
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item md={3}>
          <TextField
            variant="outlined"
            select
            label="City"
            size="small"
            fullWidth
            required
            value={cityId}
            onChange={e => setCityId(e.target.value)}
            className={`${classes.marginStyle} ${classes.inputStyle}`}>
            {allCity.map((e, index) => (
              <MenuItem value={e.id} key={index}>
                <Box className={classes.inner}> {e.name}</Box>
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item md={3}>
          <TextField
            variant="outlined"
            select
            label="Document Type"
            size="small"
            fullWidth
            required
            value={documentTypeId}
            onChange={e => setDocumentTypeId(e.target.value)}
            className={`${classes.marginStyle} ${classes.inputStyle}`}>
            {allDocumentType.map((e, index) => (
              <MenuItem value={e.id} key={index}>
                <Box className={classes.inner}> {e.name}</Box>
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        {/* <Grid item md={3}>
          <TextField
            variant="outlined"
            select
            label="Occupation"
            size="small"
            fullWidth
            required
            value={occupation}
            onChange={e => setOccupation(e.target.value)}
            className={`${classes.marginStyle} ${classes.inputStyle}`}>
            {allOccupation.map((e, index) => (
              <MenuItem value={e.id} key={index}>
                <Box className={classes.inner}> {e.name}</Box>
              </MenuItem>
            ))}
          </TextField>
        </Grid> */}

        <Grid item md={3}>
          <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            onClick={handleSearch}
            startIcon={<SearchOutlinedIcon />}>
            Search
          </Button>

          <IconButton onClick={handleClear} size="small" style={{ marginLeft: 15, background: '#ddd' }}>
            <CloseOutlinedIcon />
          </IconButton>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={12}>
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer component={Paper} className={classes.container}>
              <Table stickyHeader aria-label="simple table">
                <TableHead className={classes.tableHeadStyle}>
                  <TableRow>
                    <TableCell align="left">Name</TableCell>
                    <TableCell align="left">Gender</TableCell>

                    <TableCell align="left">Document Type</TableCell>
                    <TableCell align="left">Document ID </TableCell>
                    <TableCell align="left">Country </TableCell>
                    <TableCell align="left">State </TableCell>
                    <TableCell align="left">City </TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="center" className={classes.cellWidth}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className={classes.tableBodyStyle}>
                  {list.length > 0 && !loading
                    ? list.map((row, i) => (
                        <TableRow hover key={i}>
                          <TableCell align="left" scope="row">
                            {row.name}
                          </TableCell>
                          <TableCell align="left" scope="row">
                            {row.gender}
                          </TableCell>

                          <TableCell align="left" scope="row">
                            {row.idType}
                          </TableCell>
                          <TableCell align="left" scope="row">
                            {row.documentId}
                          </TableCell>
                          <TableCell align="left" scope="row">
                            {row.country && row.country.name}
                          </TableCell>
                          <TableCell align="left" scope="row">
                            {row.state && row.state.name}
                          </TableCell>
                          <TableCell align="left" scope="row">
                            {row.city && row.city.name}
                          </TableCell>

                          <TableCell align="left" scope="row">
                            {row.stage == 0 && <Chip label="EKYC journey not started / declined" />}
                            {row.stage == 1 && <Chip label="Document submitted" />}
                            {row.stage == 2 && <Chip label="Form Submitted" />}
                            {row.stage == 3 && <Chip label="Verified" />}
                            {row.stage == 4 && <Chip label="Approved by Admin" />}
                          </TableCell>

                          <TableCell align="center">
                            <IconButton className={classes.detailButton} onClick={() => handleClickView(row)}>
                              <VisibilityIcon />
                            </IconButton>
                            {/* <IconButton
                              className={classes.editButton}
                              onClick={() => {
                                setEditIndexNo(i);
                                getById(row.id);
                              }}>
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              color="secondary"
                              onClick={() => {
                                handleDeleteDialogClickOpen();
                                setDeleteId(row.id);
                              }}>
                              <DeleteIcon />
                            </IconButton> */}
                          </TableCell>
                        </TableRow>
                      ))
                    : null}
                  {!loading && list.length === 0 && (
                    <TableRow>
                      <TableCell colSpan="10" style={{ textAlign: 'center' }}>
                        {message}
                      </TableCell>
                    </TableRow>
                  )}
                  {loading && pageLoading()}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              rowsPerPageOptions={[]}
              count={count}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={perPage}
            />
          </Paper>
        </Grid>
      </Grid>

      <div>
        <Dialog
          open={openDetailView}
          onClose={handleCloseDetailView}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent>
            {detailViewItem ? (
              <Box>
                <TableContainer style={{ marginBottom: '40px' }}>
                  <div className={classes.titleDiv}>
                    <div className={classes.iconDiv}>
                      <IconButton
                        style={{ background: 'gainsboro' }}
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={handleCloseDetailView}>
                        <Clear fontSize="inherit" />
                      </IconButton>
                    </div>

                    <Typography variant="h1" className={` ${classes.alignCenter}`}>
                      Details
                    </Typography>
                  </div>
                  <Table className={classes.table} aria-label="simple table">
                    <TableBody>
                      <TableRow>
                        <TableCell scope="row" />
                        <TableCell align="right" />
                      </TableRow>
                      <TableRow>
                        <TableCell scope="row">First Name</TableCell>
                        <TableCell align="right">{detailViewItem.firstName}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell scope="row">Last Name</TableCell>
                        <TableCell align="right">{detailViewItem.lastName}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell scope="row">Username</TableCell>
                        <TableCell align="right">{detailViewItem.username}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell scope="row">DOB</TableCell>
                        <TableCell align="right">{detailViewItem.dob}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell scope="row">Gender</TableCell>
                        <TableCell align="right">{detailViewItem.gender}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell scope="row">Blood Group</TableCell>
                        <TableCell align="right">{detailViewItem.bloodGroup}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell scope="row">Id Type</TableCell>
                        <TableCell align="right">{detailViewItem.idType}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell scope="row">Country Name</TableCell>
                        <TableCell align="right">{detailViewItem.countryName}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell scope="row">Issue Date</TableCell>
                        <TableCell align="right">{detailViewItem.issueDate}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell scope="row">Expiry Date</TableCell>
                        <TableCell align="right">{detailViewItem.expiryDate}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell scope="row">Front Side Image</TableCell>
                        <TableCell align="right">
                          <img
                            src={detailViewItem.frontSideImage}
                            height="200"
                            alt=""
                            className={classes.image}
                            onClick={() => {
                              setPopupImage(detailViewItem.frontSideImage);
                              openAddDialogImage();
                            }}
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell scope="row">Back Side Image</TableCell>
                        <TableCell align="right">
                          <img
                            src={detailViewItem.backSideImage}
                            height="200"
                            alt=""
                            className={classes.image}
                            onClick={() => {
                              setPopupImage(detailViewItem.backSideImage);
                              openAddDialogImage();
                            }}
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell scope="row">User Image</TableCell>
                        <TableCell align="right">
                          <img
                            src={detailViewItem.userImage}
                            height="200"
                            alt=""
                            className={classes.image}
                            onClick={() => {
                              setPopupImage(detailViewItem.userImage);
                              openAddDialogImage();
                            }}
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell scope="row">Selfie Image</TableCell>
                        <TableCell align="right">
                          <img
                            src={detailViewItem.selfieImage}
                            height="200"
                            alt=""
                            className={classes.image}
                            onClick={() => {
                              setPopupImage(detailViewItem.selfieImage);
                              openAddDialogImage();
                            }}
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell scope="row">Selfie Image Percentage</TableCell>
                        <TableCell align="right">{detailViewItem.selfieImagePercentage}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell scope="row">Stage</TableCell>
                        <TableCell align="right">
                          {detailViewItem.stage == 0 && 'EKYC journey not started / declined'}
                          {detailViewItem.stage == 1 && 'Document submitted'}
                          {detailViewItem.stage == 2 && 'Form Submitted'}
                          {detailViewItem.stage == 3 && 'Verified'}
                          {detailViewItem.stage == 4 && 'Approved by Admin'}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  {detailViewItem.stage == 3 && (
                    <form onSubmit={e => handleApprove(e, detailViewItem.userId)}>
                      <Box style={{ marginTop: '20px' }}>
                        <TextField
                          variant="outlined"
                          select
                          label="Please Select"
                          size="small"
                          fullWidth
                          required
                          value={eKycApproval}
                          onChange={e => setEKycApproval(e.target.value)}
                          className={`${classes.marginStyle} ${classes.inputStyle}`}>
                          <MenuItem value="APPROVE">
                            <Box className={classes.inner}>APPROVE</Box>
                          </MenuItem>
                          <MenuItem value="DECLINE">
                            <Box className={classes.inner}>DECLINE</Box>
                          </MenuItem>
                        </TextField>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          marginTop: 2,
                        }}>
                        <LoadingButton color="secondary" variant="contained" loading={loading} type="submit">
                          Submit
                        </LoadingButton>
                      </Box>
                    </form>
                  )}
                  {(detailViewItem.stage == 1 || detailViewItem.stage == 2) && (
                    <form onSubmit={e => handleApprove(e, detailViewItem.userId)}>
                      <Box style={{ marginTop: '20px' }}>
                        <TextField
                          variant="outlined"
                          select
                          label="Please Select"
                          size="small"
                          fullWidth
                          required
                          value={eKycApproval}
                          onChange={e => setEKycApproval(e.target.value)}
                          className={`${classes.marginStyle} ${classes.inputStyle}`}>
                          <MenuItem value="DECLINE">
                            <Box className={classes.inner}>DECLINE</Box>
                          </MenuItem>
                        </TextField>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          marginTop: 2,
                        }}>
                        <LoadingButton color="secondary" variant="contained" loading={loading} type="submit">
                          Submit
                        </LoadingButton>
                      </Box>
                    </form>
                  )}
                </TableContainer>
              </Box>
            ) : null}
          </DialogContent>
        </Dialog>
      </div>
      {/* ==================Image Dialog start============================== */}

      <div>
        <Dialog
          maxWidth="md"
          open={addDialogImage}
          onClose={closeAddDialogImage}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent className={classes.dialogStyleImage}>
            <IconButton onClick={closeAddDialogImage} style={{ float: 'right' }}>
              <CloseOutlinedIcon />
            </IconButton>
            <div style={{ textAlign: 'center' }}>
              <img src={popupImage} alt="" style={{ maxWidth: '100%', margin: 'auto' }} />
            </div>
          </DialogContent>
        </Dialog>
      </div>
      {/* ==================Add Dialog start============================== */}

      <div>
        <Dialog
          open={addDialog}
          onClose={closeAddDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent className={classes.dialogStyle}>
            {/* <AgentReqEdit
              list={list}
              allCountry={allCountry}
              setList={setList}
              editObj={editObj}
              setEditObj={setEditObj}
              editIndexNo={editIndexNo}
              refresh={refresh}
              setRefresh={setRefresh}
              closeAddDialog={closeAddDialog}
              addDialog={addDialog}
            /> */}
          </DialogContent>
        </Dialog>
      </div>

      {/* ==================Add Dialog End============================== */}
      {/* ==================Delete Dialogue start============================== */}
      <div>
        <Dialog
          open={deleteDialog}
          onClose={handleDeleteDialogClose}
          PaperProps={{
            style: {
              minWidth: '400px',
              boxShadow: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingBottom: '20px',
            },
          }}>
          <DialogContent>
            <DialogTitle>
              <Typography variant="h3">Are you sure to delete ?</Typography>
            </DialogTitle>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteDialogClose} variant="outlined">
              Cancel
            </Button>
            <LoadingButton loading={loadingDelete} color="secondary" onClick={handleDelete} autoFocus variant="contained">
              Delete
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </div>
      {/* ==================Delete Dialogue End============================== */}
    </React.Fragment>
  );
};

export default KycList;
